import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Home, Search } from "lucide-react";

export default function CatNotFound() {
  return (
    <>
      <Helmet>
        <title>Chat introuvable | Savoinimaux</title>
        <meta
          name="robots"
          content="noindex,nofollow"
        />
      </Helmet>

      <section className="flex min-h-[70vh] items-center justify-center bg-[#f8f5f0] px-6 py-20">
        <div className="max-w-xl text-center">
          <div className="mx-auto mb-8 flex h-24 w-24 items-center justify-center rounded-full bg-red-50">
            <Search className="h-11 w-11 text-red-600" />
          </div>

          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.35em] text-red-600">
            Oups...
          </p>

          <h1 className="text-5xl font-bold text-[#111111]">
            Chat introuvable
          </h1>

          <p className="mt-6 text-lg leading-8 text-black/60">
            Ce chat n'est plus disponible à l'adoption ou cette page n'existe
            plus.
          </p>

          <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row">
            <Link
              to="/adoption"
              className="inline-flex items-center justify-center rounded-full bg-red-600 px-7 py-4 font-semibold text-white transition hover:bg-red-700"
            >
              Voir tous nos chats
            </Link>

            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-gray-300 bg-white px-7 py-4 font-semibold text-[#111111] transition hover:bg-gray-50"
            >
              <Home className="h-5 w-5" />
              Retour à l'accueil
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}